import OrigenDeudaList from './OrigenDeudaList'
export {OrigenDeudaList}
export default OrigenDeudaList
